import {computed, onMounted, ref, watch} from "vue";
import {useQuery, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";

const useUser = () => {
  const query = useQuery({
    queryKey: ['current-user'],
    queryFn: () => axios.get('/ajax/v2/user'),
  });

  const user = computed(() => query.data.value?.data?.data);

  const hasFeature = (feature) => user.value?.features[feature] === true;

  const hasAccessToOptimiser = computed(() => user.value?.optimiser_access);
  // only used on sitemap page and NOT ai-onboarding
  const hasSitemapAiAutoAssignFeature = computed(() => hasFeature('SitemapAiAutoAssignFeature'));
  const isAdmin = computed(() => ['ADMIN', 'DEVELOPER'].includes(user.value?.user_type));
  const isDeveloper = computed(() => user.value?.user_type === 'DEVELOPER');
  const isOnTrial = computed(() => user.value?.on_trial);
  const isSubscribedToKit = computed(() => user.value?.subscribed_to_kit === true);

  return {
    ...query,
    user,
    hasFeature,
    hasSitemapAiAutoAssignFeature,
    hasAccessToOptimiser,
    isAdmin,
    isDeveloper,
    isOnTrial,
    isSubscribedToKit,
  };
};

export default useUser;
